import { Grid } from "@mui/joy"
import { useDispatch } from "react-redux"

function Home() {
    var dispatch = useDispatch()
    return <Grid container>
       Home
    </Grid>
}

export default Home